'use strict';
var Facebook, Form, Google, SignInFlyout;

Facebook = require('./facebook');

Google = require('./google');

Form = require('./form');

SignInFlyout = {
  init: function() {
    this.$menu = $('#ls-user-signin-with-flyout');
    this.$flyout = $('#ls-signin-flyout');
    if (!(this.$menu.length && this.$flyout.length)) {
      return;
    }
    this.hideFlyoutTimer = null;
    this.isActive = false;
    Google.init(this);
    Facebook.init(this);
    return Form.init(this);
  },
  bind: function() {
    $(document).on({
      keyup: (function(_this) {
        return function(e) {
          if (e.keyCode === Groupon.Keymap.ESCAPE) {
            return _this.hideFlyoutWithoutDelay();
          }
        };
      })(this),
      click: (function(_this) {
        return function(e) {
          return _this.hideFlyoutIfClickOutside(e);
        };
      })(this)
    });
    if (Groupon.LS.hasTouch) {
      this.$menu.on('touchend', (function(_this) {
        return function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          $('html').trigger('tap');
          if (_this.$flyout.hasClass('show')) {
            return _this.hideFlyoutWithoutDelay();
          } else {
            _this.showFlyout();
            return $('html').off('tap.signin').one('tap.signin', function(evt) {
              return _this.hideFlyoutIfClickOutside(evt);
            });
          }
        };
      })(this));
    }
    $('#ls-user-signin-with-flyout').on('focus', (function(_this) {
      return function() {
        return _this.showFlyout();
      };
    })(this));
    $('#ls-user-signin-with-flyout, #ls-signin-flyout').on({
      'mouseover': (function(_this) {
        return function() {
          return _this.showFlyout();
        };
      })(this),
      'mouseout': (function(_this) {
        return function() {
          return _this.hideFlyout();
        };
      })(this)
    });
    return $('#ls-signin-flyout, #ls-signin-flyout input, #ls-signin-flyout button, #ls-signin-flyout a').on({
      'focus': (function(_this) {
        return function() {
          return _this.isActive = true;
        };
      })(this),
      'blur': (function(_this) {
        return function() {
          return _this.isActive = false;
        };
      })(this)
    });
  },
  hideFlyoutIfClickOutside: function(e) {
    if ($(e.target).closest('.signin-flyout-menu-item, .ls-signin-flyout, .ls-signin-form').length === 0) {
      return this.hideFlyoutWithoutDelay();
    }
  },
  showFlyout: function() {
    $('#ls-signin-flyout').addClass('show');
    if (this.hideFlyoutTimer) {
      return window.clearTimeout(this.hideFlyoutTimer);
    }
  },
  hideFlyoutWithoutDelay: function() {
    return $('#ls-signin-flyout').removeClass('show');
  },
  hideFlyout: function() {
    if (this.isActive) {
      return;
    }
    window.clearTimeout(this.hideFlyoutTimer);
    return this.hideFlyoutTimer = window.setTimeout((function(_this) {
      return function() {
        return _this.hideFlyoutWithoutDelay();
      };
    })(this), 250);
  },
  successMetric: function() {
    try {
      return OptimizeSuite.InteractionGoals.successMetric({
        type: 'layout_login'
      });
    } catch (error) {}
  }
};

module.exports = SignInFlyout;

